import {KebabHorizontalIcon} from '@primer/octicons-react'

export function HunkKebabIcon() {
  return (
    <div className="hunk-kebab-icon pr-2 pb-1">
      <KebabHorizontalIcon />
    </div>
  )
}
